  jQuery(document).ready(function () {
    jQuery('#shopify-section-template--18954466885782__image_gallery_XUWeim .hdt-spacing-20').slick({
      dots: false, 
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000, 
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1 }
        }
      ]
    });
  });


  jQuery(document).ready(function () {
    jQuery('#shopify-section-template--18954466885782__image_gallery_PGiNFC .hdt-spacing-20').slick({
      dots: false, 
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000, 
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1 }
        }
      ]
    });
  });